var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{attrs:{"rules":_vm.rules,"accept":"image/png, image/jpeg, image/bmp","placeholder":"Pick an avatar","prepend-icon":"mdi-camera","label":"Avatar"}})}
var staticRenderFns = []

export { render, staticRenderFns }